// extracted by mini-css-extract-plugin
export default {"container":"Pdv_container__+eC1P","page":"Pdv_page__4UCCF"};